import { Fragment } from 'react';
import { Box, IconButton, Link, Stack, Typography, useTheme } from '@mui/material';
import goLogo from '../assets/go-logo.svg';
import ArrowBack from '@mui/icons-material/ArrowBack';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import { MenuItem } from './MenuItem.tsx';
import { RouteType, SubRouteType } from '../routes';
import { useApplicationContext } from '../contexts/ApplicationContext/ApplicationContext.tsx';
import { StudentApplicationValues } from '../student/application/StudentApplication.ts';

interface MenuBarProps {
  routes: RouteType;
}

export const Menubar = ({ routes }: MenuBarProps) => {
  const theme = useTheme();
  const { url, subRoutes } = routes;
  const { applicationProgress, displayErrors } = useApplicationContext();

  const renderMenuItems = (routesToRender: Record<string, SubRouteType>) => {
    const routesArray = Object.entries(routesToRender);
    return routesArray.map(([key, route], i) => {
      const page = key as keyof StudentApplicationValues;
      const routeUrl = `/${url}/${route.url}`;
      const pageProgress = applicationProgress?.[page];
      return (
        <MenuItem
          key={routeUrl}
          href={routeUrl}
          label={route.label}
          last={i === routesArray.length - 1}
          sections={route.sections}
          pageProgress={pageProgress}
          displayErrors={displayErrors}
        />
      );
    });
  };

  return (
    <Stack direction="column" py={3}>
      <Box mb={3} textAlign="center">
        <Box component="img" src={goLogo} sx={{ width: theme.spacing(8) }} />
      </Box>
      <Stack px={2} direction="row" alignItems="center" gap={1} mb={2}>
        <IconButton color="secondary" sx={theme.mixins.roundedIconButton}>
          <ArrowBack sx={{ width: 24, height: 24 }} />
        </IconButton>
        <Stack direction="row" flexWrap="wrap" gap={1} alignItems="center">
          <Link href="/">
            <Typography color="primary" sx={{ textDecoration: `underline ${theme.palette.primary[50]}` }}>
              Home
            </Typography>
          </Link>
          <ArrowForwardIosIcon color="secondary" sx={{ width: 16, height: 16 }} />
          <Stack direction="row" gap={1}>
            <StarOutlineIcon color="secondary" />
            <Typography>Application</Typography>
          </Stack>
        </Stack>
      </Stack>

      {subRoutes &&
        subRoutes.map(({ group, routes }, index) => (
          <Fragment key={index}>
            {group && (
              <Box key={group} p={1} textAlign="center" bgcolor={theme.palette.grey[700]}>
                <Typography color="white" variant="body2">
                  {group}
                </Typography>
              </Box>
            )}
            {renderMenuItems(routes)}
          </Fragment>
        ))}
    </Stack>
  );
};
